import { useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { useAccount } from "@/context/AccountContext";
import { accountApi, errorMessage } from "@/lib/api";

export const VerifyBanner = () => {
  const { customer } = useAccount();
  const [loading, setLoading] = useState(false);

  const resend = async () => {
    setLoading(true);
    try {
      await accountApi.post("/account/resend-verification");
      toast.success("Link inviato", { description: `Controlla la casella di ${customer.email}.` });
    } catch (err) {
      toast.error(errorMessage(err, "Invio non riuscito, riprova tra poco."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="account-verify-banner" className="border-l-2 border-amber-300 bg-amber-300/10 p-5">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-200">
        <MailWarning className="h-4 w-4" /> Conferma la tua email
      </p>
      <p className="mt-3 text-sm leading-relaxed text-bone/80">
        Ti ho inviato un link a <span className="text-bone">{customer.email}</span>. Appena lo apri, qui compaiono tutti i tuoi ordini (anche quelli fatti prima di registrarti) e lo stato delle spedizioni.
      </p>
      <button
        type="button"
        onClick={resend}
        disabled={loading}
        data-testid="account-resend-verification-button"
        className="mt-4 inline-flex h-10 items-center rounded-full border border-bone/30 px-5 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors hover:border-acid hover:text-acid disabled:opacity-60"
      >
        {loading ? "Invio…" : "Invia di nuovo il link"}
      </button>
    </div>
  );
};
